import React from "react";

const WebsiteThemeContext = React.createContext();

export default WebsiteThemeContext;
